import { LOADING } from "../../../constants/constant";
import {
  GET_ALL_REPORT_LISTS_REQUESTED,
  GET_ALL_REPORT_LISTS_SUCCESS,
  GET_ALL_REPORT_LISTS_FAILED,
  GET_ALL_REPORT_LISTS_RESET,
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: true,
};

export default function getReportsFilterDataReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_REPORT_LISTS_REQUESTED:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case GET_ALL_REPORT_LISTS_SUCCESS:
      let userRes = Object.assign({}, state);
      userRes.status = action.data?.status_message;
      userRes.statusCode = action.data?.status_code;
      userRes.isLoading = false;
      userRes.brandList = action.data?.data?.brand;
      userRes.botList = action.data?.data?.bots;
      return userRes;

    case GET_ALL_REPORT_LISTS_FAILED:
      return Object.assign({}, state, action.error);

    case GET_ALL_REPORT_LISTS_RESET:
      return initialState;

    default:
      return state;
  }
}

